import { writable } from 'svelte/store'

export let y = writable(0)

export let hideLabels = writable(false)
export let showModal = writable(false)

export let showLabelPage = writable(false)
export let showSpecimenPage = writable(false)
export let calledFromLabel = writable(null)

export let posBeforeLabel = writable(null)
export let posBeforeBuy = writable(null)
